<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="日期范围：">
            <el-date-picker size="medium" v-model="searchForm.DAY" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="handleCurrentChange(1)" style="float:right">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" plain @click="exportTable" style="float:right">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col>
        <el-table border stripe :data="tableData">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="DELIVER_DAY" label="出库日期"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="出库数量"></el-table-column>
          <el-table-column prop="TOTAL_FEE" label="出库总金额"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span>{{ showStatus[scope.row.STATUS - 1] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" v-if="scope.row.STATUS == 1" @click="dealDelivey(scope.row)">预处理
              </el-button>
              <el-button size="small" type="text" v-if="scope.row.STATUS == 2" @click="reportLoss(scope.row)">报损
              </el-button>
              <el-button size="small" type="text" @click="openDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog center :visible.sync="InfoFormVisible" width="600px">
      <p>{{ errorInfo }}</p>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="InfoFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { totalOutFun, dealFun } from 'api/warehouseManager';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {},
      tableData: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      showStatus: ['已出库', '已预处理', '已完成'],
      errorInfo: '',
      InfoFormVisible: false,
    };
  },
  computed: {
    SAVE_TOTAL_OUT_DOC() {
      return this.$store.state.TOTAL_OUT_DOC_LIST;
    },
  },
  methods: {
    exportTable() {
      const params = {
        SERVICE_ID: '10058',
        OTYPE: 17,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.DAY) {
        params.START_DAY = this.searchForm.DAY[0];
        params.END_DAY = this.searchForm.DAY[1];
      }
      http.post(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryKind() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.DAY) {
        params.START_DATE = this.searchForm.DAY[0];
        params.END_DATE = this.searchForm.DAY[1];
      }
      totalOutFun(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].LIST;
          this.totalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_TOTAL_OUT_DOC_LIST', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryKind();
    },
    openDetail(row) {
      this.$router.push({ name: 'totalOutDetail' });
      sessionStorage.setItem('deliverId', row.ID);
      sessionStorage.setItem('deliverStatus', row.STATUS);
    },
    dealDelivey(row) {
      const params = {
        DELIVER_ID: row.ID,
        SEND_DAY: row.DELIVER_DAY,
      };
      dealFun(params).then((result) => {
        this.$message.show({ text: '处理完成', type: 'success' });
        this.queryKind();
      }).catch((error) => {
        this.InfoFormVisible = true;
        this.errorInfo = error;
      });
    },
    reportLoss(row) {
      this.$router.push({ name: 'reportLoss' });
      sessionStorage.setItem('deliverId', row.ID);
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (JSON.stringify(this.SAVE_TOTAL_OUT_DOC) != '{}' && this.SAVE_TOTAL_OUT_DOC != 'undefined') {
      this.searchForm = this.SAVE_TOTAL_OUT_DOC.CONDITION;
      this.currentPage = this.SAVE_TOTAL_OUT_DOC.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryKind();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/warehouseManage/totalOutWareDoc.vue